module.exports = __webpack_public_path__ + "static/bentonsans-book-webfont-31df077adac4c559fe6b3ad4091a9721.woff";